import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import actions from './actions';

export function* getSelects() {
    yield takeEvery(actions.FETCH_SELECTS_REQUESTED, function* (action) {
        try {
          const pillverySelects = yield call(actions.getPillverySelects, action.payload);
          yield put({ type: actions.FETCH_SELECTS_SUCCEEDED, pillverySelects });
        } catch (error) {
          yield put({ type: actions.FETCH_SELECTS_FAILED, error: error.message });
        }
    });
}

export function* getSelect() {
    yield takeEvery(actions.FETCH_SELECT_REQUESTED, function* (action) {
        try {
            const selectData = yield call(actions.getPillverySelect, action.payload);
            yield put({ type: actions.FETCH_SELECT_SUCCEEDED, selectData: selectData.select_info });
        } catch (error) {
            yield put({ type: actions.FETCH_SELECT_FAILED, error: error.message });
        }
    });
}

export function* deleteSelect() {
  yield takeEvery(actions.DELETE_SELECT_REQUESTED, function* (action) {
      try {
          const select = yield call(actions.deleteSelect, action.payload);
          yield put({ type: actions.DELETE_SELECT_SUCCEEDED, selectDeleted: select });
      } catch (error) {
          yield put({ type: actions.DELETE_SELECT_FAILED, error: error.message });
      }
  });
}

export default function* rootSaga() {
  yield all([
    fork(getSelects),
    fork(getSelect),
    fork(deleteSelect),
  ]);
}
